import styled from "styled-components";

const Form = styled.form`
  
  input:not(:focus):not(:placeholder-shown):invalid {
    border-color: red;
  }

  input:not(:focus):not(:placeholder-shown):valid {
    border-color: green;
  }
`;

export default Form;
